import { useHistory } from 'react-router';
import {
  TOPBAR_HEIGHT,
  SIDEBAR_WIDTH,
  SIDEBAR_WIDE_WIDTH
} from 'common/constants/SidebarView';

const useSidebarState = showNavigation => {
  const history = useHistory();
  const isSidebarPinned = true;
  const defaultSidebarWidth = isSidebarPinned
    ? SIDEBAR_WIDE_WIDTH
    : SIDEBAR_WIDTH;
  const topbarHeight = TOPBAR_HEIGHT;
  const sidebarWidth = showNavigation ? defaultSidebarWidth : 0;
  const allocationOverTimeDefaultWidth = '59vw';
  const allocationOverTimeWidth = `calc(${allocationOverTimeDefaultWidth} - ${defaultSidebarWidth})`;
  const pmReportScrollDefaultWidth = '75.5vw';
  const pmReportScrollWidth = `calc(${pmReportScrollDefaultWidth} - ${defaultSidebarWidth})`;

  const getSelectedSidebarItemByPath = sidebarButtons => {
    const locationPathname = history.location.pathname;

    let selectedItem = {};

    sidebarButtons.forEach(button => {
      const { id: buttonId, menu = [], iconColorPalette } = button;

      const sidebarItems = [button, ...menu];

      sidebarItems.map(
        ({
          path,
          title,
          topBarTitle,
          topBarIcon,
          isSelected = null,
          showBadgeInTopBar = false,
          badge = null
        }) => {
          if (path) {
            const item = {
              buttonId,
              title: topBarTitle || title,
              topBarIcon,
              iconColorPalette,
              badge: showBadgeInTopBar && badge ? badge : null
            };
            if (
              isSelected !== null ? isSelected : locationPathname.includes(path)
            ) {
              selectedItem = item;
            }
          }
          return {};
        }
      );
    });

    return selectedItem;
  };

  return {
    isSidebarPinned,
    defaultSidebarWidth,
    topbarHeight,
    sidebarWidth,
    pmReportScrollWidth,
    allocationOverTimeWidth,
    getSelectedSidebarItemByPath
  };
};

export default useSidebarState;
